import Vue from 'vue'

import MaskedInput from 'vue-text-mask'

MaskedInput.render = function (h) {
    return h('input', {
        ref: 'input',
        domProps: {
            value: this.value
        },
        on: {
            input: (event) => this.updateValue(event.target.value),
            focus: (event) => this.emitEvent(event),
            blur: (event) => this.emitEvent(event),
            keypress: (event) => this.emitEvent(event),
            change: (event) => this.$emit('change', this.$refs.input.value),
        }
    })
};
Vue.component('masked-input', MaskedInput);